import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@parcel+watcher@2.6.0_@types+node@22.10.5_@vue+_3aebbb0ff1e217a3d317494d93a9f6c1/node_modules/nuxt/dist/pages/runtime/validate.js";
import default_45global from "/vercel/path0/apps/zefire-spa/middleware/default.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@parcel+watcher@2.6.0_@types+node@22.10.5_@vue+_3aebbb0ff1e217a3d317494d93a9f6c1/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  default_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}